import { Injectable } from '@angular/core';

import { Query, gql } from 'apollo-angular';

import { LocalizableNameArgs, StoreConfiguration } from '@hdms/shared/common-types';

export interface FinHubConfigurationResponse {
  storeConfiguration: StoreConfiguration;
}

@Injectable({
  providedIn: 'root'
})
export class FinHubConfigurationGqlService extends Query<FinHubConfigurationResponse, LocalizableNameArgs> {
  override document = gql`
    query FinHubConfiguration($localization: LocalizationInput!) {
      storeConfiguration(localization: $localization) {
        id
        common {
          softwareSubscriptionManagement
        }
      }
    }
  `;
}
